import { render, staticRenderFns } from "./ViewOrders.vue?vue&type=template&id=0059c6b6&scoped=true"
import script from "./ViewOrders.vue?vue&type=script&lang=js"
export * from "./ViewOrders.vue?vue&type=script&lang=js"
import style0 from "./ViewOrders.vue?vue&type=style&index=0&id=0059c6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059c6b6",
  null
  
)

export default component.exports